export default __webpack_public_path__ + "static/phone-frame-e3d0f87be43505bc866e63974b391e40.png";